<template>
  <div v-if="visible" class="theme-debug-switch">
    <button
      v-for="item in themeOptions"
      :key="item.name"
      type="button"
      :class="{ active: item.name === activeTheme }"
      @click="switchTheme(item.name)"
    >
      {{ item.label }}
    </button>
    <button type="button" class="close" @click="hidePanel">收起</button>
  </div>
</template>

<script setup lang="ts">
import { onMounted, ref } from 'vue'
import {
  appThemeConfig,
  appThemeNames,
  applyAppTheme,
  getCurrentThemeName,
  isThemeDebugVisible,
  setThemeDebugVisible,
  setThemeOverride,
  type AppThemeName,
} from '@/theme/appTheme'

const visible = ref(false)
const activeTheme = ref<AppThemeName>(appThemeConfig.currentTheme)

const themeOptions = appThemeNames.map((name) => ({
  name,
  label: appThemeConfig.themes[name].label,
}))

const switchTheme = (themeName: AppThemeName) => {
  activeTheme.value = themeName
  setThemeOverride(themeName)
}

const hidePanel = () => {
  visible.value = false
  setThemeDebugVisible(false)
}

onMounted(() => {
  visible.value = isThemeDebugVisible()
  activeTheme.value = getCurrentThemeName()
  applyAppTheme(activeTheme.value)
  window.addEventListener('app-theme-change', ((event: CustomEvent<{ theme: AppThemeName }>) => {
    activeTheme.value = event.detail.theme
  }) as EventListener)
})
</script>

<style lang="less" scoped>
.theme-debug-switch {
  position: fixed;
  right: 0.12rem;
  bottom: calc(0.28rem + env(safe-area-inset-bottom));
  z-index: 9999;
  display: flex;
  align-items: center;
  gap: 0.04rem;
  padding: 0.04rem;
  border: 1px solid var(--border-default);
  border-radius: 0.08rem;
  background: var(--bg-card);
  box-shadow: 0 0.04rem 0.14rem rgba(0, 0, 0, 0.18);
}

button {
  height: 0.28rem;
  min-width: 0.44rem;
  padding: 0 0.08rem;
  border: 0;
  border-radius: 0.06rem;
  color: var(--text-secondary);
  background: transparent;
  font-size: 0.12rem;
}

button.active {
  color: #19191e;
  background: var(--gradient-primary);
  font-weight: 600;
}

button.close {
  color: var(--text-muted);
}
</style>
